
import './App.css';
import ForgatePassword from './Login/ForgatePassword';
import Login from './Login/Login';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Pages/Dashbord/Dashboard';
import AddWorkshop from './Pages/Dashbord/AddWorkshop';
import Notification from './Pages/Dashbord/Notification';

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path='/' element={<Login></Login>}></Route>
          <Route path='/forgatepassword' element={<ForgatePassword></ForgatePassword>}></Route>
          <Route path='/dashboard' element={<Dashboard></Dashboard>}></Route>
          <Route path='/addworkshop' element={<AddWorkshop></AddWorkshop>}></Route>
          <Route path='/notification' element={<Notification></Notification>}></Route>
        </Routes>
       
      </div>
    </Router>

  );
}

export default App;
